import $ from 'jquery';
import { showTips, compareTime, isMobile } from './utils';
import api from './api';
import {
    state,
    numMap,
    bagArr,
    quizArr,
    basicInit,
    getText,
    jumpLink,
    checkLogin,
    gotoLogin,
    roleInfoInit
} from './main';
import { fbShare } from './share';
import { isSdk } from './sdkCtrl'

const tipArr1 = ['16-1', '16-2', '16-3', '16-4', '16-5', '16-6', '16-7', '16-8'];
const tipArr2 = ['16-9', '16-10', '16-11', '16-12', '16-13', '16-14', '16-15', '16-16'];
const tipArr3 = ['16-17', '16-18', '16-19', '16-20', '16-21', '16-22', '16-23', '16-24'];
const tipArr4 = ['16-25', '16-26', '16-27', '16-28', '16-29', '16-30', '16-31', '16-32'];
const tipArr5 = ['8-1', '8-2', '8-3', '8-4', '8-5', '8-6', '8-7', '8-8'];
const tipArr6 = ['8-9', '8-10', '8-11', '8-12', '8-13', '8-14', '8-15', '8-16'];
const tipArr7 = ['4-1', '4-2', '4-3', '4-4', '2-1', '2-2'];
const tipArr8 = ['4-5', '4-6', '4-7', '4-8'];
const tipArr9 = ['1-1', '1-2'];
const tipArr10 = ['1-3', '1-4'];

const zanMap = {
    1: 2,
    2: 1,
    3: 4,
    4: 3,
    5: 6,
    6: 5,
    7: 8,
    8: 7,
}

export const initBindEvent = () => {
    if (isMobile()) {
        if (isSdk) {
            $('.j-popup-quiznoopenbtn').attr('data-scroll', '.h .part2')
        } else {
            $('.j-popup-quiznoopenbtn').attr('data-scroll', '.m .part2')
        }
    }
    $('body').on('click', '.j-collect', ({ currentTarget }) => {
        let eventType = currentTarget.dataset.eventtype;
        window.activityDataLayer.push({
            eventName: "click_button",
            eventType: eventType,
            aid: "dlssrvtline2",
            gameId: 274
        })
    });
    $('.j-vi-schedule').on('click', () => {
        $('.j-vi-schedule').addClass('active');
        $('.j-th-schedule').removeClass('active');
        $('.j-final-schedule').removeClass('active');
        $('.j-vi-schedule-btn-list').show();
        $('.j-th-schedule-btn-list').hide();
        $('.j-final-schedule-btn').hide();
        $('.j-vi-schedule-block').show();
        $('.j-th-schedule-block').hide();
        $('.j-final-schedule-block').hide();
    });
    $('.j-th-schedule').on('click', () => {
        $('.j-vi-schedule').removeClass('active');
        $('.j-th-schedule').addClass('active');
        $('.j-final-schedule').removeClass('active');
        $('.j-vi-schedule-btn-list').hide();
        $('.j-th-schedule-btn-list').show();
        $('.j-final-schedule-btn').hide();
        $('.j-vi-schedule-block').hide();
        $('.j-th-schedule-block').show();
        $('.j-final-schedule-block').hide();
    });
    $('.j-final-schedule').on('click', () => {
        $('.j-vi-schedule').removeClass('active');
        $('.j-th-schedule').removeClass('active');
        $('.j-final-schedule').addClass('active');
        $('.j-vi-schedule-btn-list').hide();
        $('.j-th-schedule-btn-list').hide();
        $('.j-final-schedule-btn').show();
        $('.j-vi-schedule-block').hide();
        $('.j-th-schedule-block').hide();
        $('.j-final-schedule-block').show();
    });
    $('.j-copyright').on('click', () => {
        $('.j-footer').toggleClass('active');
    });
    $('.j-float-open').on('click', function () {
        $('.j-float-open').removeClass("show");
        $('.j-float').addClass("show");
    });
    $('.j-float-close').on('click', function () {
        $('.j-float').removeClass("show");
        $('.j-float-open').addClass("show");
    });
    $('.j-game-rule').on('click', () => {
        $('.j-popup').fadeOut();
        $('.j-popup-rule').fadeIn()
    });
    for (let i = 1; i < 9; i++) {
        $('.j-quiz-item-btn' + i).on('click', () => {
            if (!state.isLogin) {
                gotoLogin();
                return;
            }
            if (!state.isBind) {
                bindInit();
                $('.j-popup').fadeOut();
                $('.j-popup-juese').fadeIn()
                return;
            }
            state.matchId = $('.j-quiz-item-btn' + i).attr('data-id');
            state.curZan = i;
            if (state.matchId && state.curZan) {
                window.activityDataLayer.push({
                    eventName: "click_button",
                    eventReason: state.matchId,
                    aid: "dlssrvtline2",
                    gameId: 274
                })
                if (tipArr1.includes(state.matchId)) {
                    if (compareTime('2023/03/06,00:00:00', '2023/03/06,20:00:00') === -1) {
                        $('.j-popup').fadeOut();
                        $('.j-popup-quiznoopen').fadeIn();
                        return;
                    }
                    if (compareTime('2023/03/06,00:00:00', '2023/03/06,20:00:00') === 1) {
                        showTips(getText('quizEnd'));
                        return;
                    }
                    $('.j-popup').fadeOut();
                    $('.j-popup-quizconfirm').fadeIn();
                }
                if (tipArr2.includes(state.matchId)) {
                    if (compareTime('2023/03/06,00:00:00', '2023/03/07,20:00:00') === -1) {
                        $('.j-popup').fadeOut();
                        $('.j-popup-quiznoopen').fadeIn();
                        return;
                    }
                    if (compareTime('2023/03/06,00:00:00', '2023/03/07,20:00:00') === 1) {
                        showTips(getText('quizEnd'));
                        return;
                    }
                    $('.j-popup').fadeOut();
                    $('.j-popup-quizconfirm').fadeIn();
                }
                if (tipArr3.includes(state.matchId)) {
                    if (compareTime('2023/03/01,00:00:00', '2023/03/01,20:00:00') === -1) {
                        $('.j-popup').fadeOut();
                        $('.j-popup-quiznoopen').fadeIn();
                        return;
                    }
                    if (compareTime('2023/03/01,00:00:00', '2023/03/01,20:00:00') === 1) {
                        showTips(getText('quizEnd'));
                        return;
                    }
                    $('.j-popup').fadeOut();
                    $('.j-popup-quizconfirm').fadeIn();
                }
                if (tipArr4.includes(state.matchId)) {
                    if (compareTime('2023/03/01,00:00:00', '2023/03/03,20:00:00') === -1) {
                        $('.j-popup').fadeOut();
                        $('.j-popup-quiznoopen').fadeIn();
                        return;
                    }
                    if (compareTime('2023/03/01,00:00:00', '2023/03/03,20:00:00') === 1) {
                        showTips(getText('quizEnd'));
                        return;
                    }
                    $('.j-popup').fadeOut();
                    $('.j-popup-quizconfirm').fadeIn();
                }
                if (tipArr5.includes(state.matchId)) {
                    if (compareTime('2023/03/08,08:00:00', '2023/03/10,20:00:00') === -1) {
                        $('.j-popup').fadeOut();
                        $('.j-popup-quiznoopen').fadeIn();
                        return;
                    }
                    if (compareTime('2023/03/08,08:00:00', '2023/03/10,20:00:00') === 1) {
                        showTips(getText('quizEnd'));
                        return;
                    }
                    $('.j-popup').fadeOut();
                    $('.j-popup-quizconfirm').fadeIn();
                }
                if (tipArr6.includes(state.matchId)) {
                    if (compareTime('2023/03/05,08:00:00', '2023/03/09,20:00:00') === -1) {
                        $('.j-popup').fadeOut();
                        $('.j-popup-quiznoopen').fadeIn();
                        return;
                    }
                    if (compareTime('2023/03/05,08:00:00', '2023/03/09,20:00:00') === 1) {
                        showTips(getText('quizEnd'));
                        return;
                    }
                    $('.j-popup').fadeOut();
                    $('.j-popup-quizconfirm').fadeIn();
                }
                if (tipArr7.includes(state.matchId)) {
                    if (compareTime('2023/03/11,08:00:00', '2023/03/14,20:00:00') === -1) {
                        $('.j-popup').fadeOut();
                        $('.j-popup-quiznoopen').fadeIn();
                        return;
                    }
                    if (compareTime('2023/03/11,08:00:00', '2023/03/14,20:00:00') === 1) {
                        showTips(getText('quizEnd'));
                        return;
                    }
                    $('.j-popup').fadeOut();
                    $('.j-popup-quizconfirm').fadeIn();
                }
                if (tipArr8.includes(state.matchId)) {
                    if (compareTime('2023/03/10,08:00:00', '2023/03/10,20:00:00') === -1) {
                        $('.j-popup').fadeOut();
                        $('.j-popup-quiznoopen').fadeIn();
                        return;
                    }
                    if (compareTime('2023/03/10,08:00:00', '2023/03/10,20:00:00') === 1) {
                        showTips(getText('quizEnd'));
                        return;
                    }
                    $('.j-popup').fadeOut();
                    $('.j-popup-quizconfirm').fadeIn();
                }
                if (tipArr9.includes(state.matchId)) {
                    if (compareTime('2023/03/15,08:00:00', '2023/03/17,20:00:00') === -1) {
                        $('.j-popup').fadeOut();
                        $('.j-popup-quiznoopen').fadeIn();
                        return;
                    }
                    if (compareTime('2023/03/15,08:00:00', '2023/03/17,20:00:00') === 1) {
                        showTips(getText('quizEnd'));
                        return;
                    }
                    $('.j-popup').fadeOut();
                    $('.j-popup-quizconfirm').fadeIn();
                }
                if (tipArr10.includes(state.matchId)) {
                    if (compareTime('2023/03/11,08:00:00', '2023/03/17,20:00:00') === -1) {
                        $('.j-popup').fadeOut();
                        $('.j-popup-quiznoopen').fadeIn();
                        return;
                    }
                    if (compareTime('2023/03/11,08:00:00', '2023/03/17,20:00:00') === 1) {
                        showTips(getText('quizEnd'));
                        return;
                    }
                    $('.j-popup').fadeOut();
                    $('.j-popup-quizconfirm').fadeIn();
                }
            } else {
                $('.j-popup').fadeOut();
                $('.j-popup-quiznoopen').fadeIn();
            }

        });
    }
    $('.j-popup-quizconfirmbtn').on('click', async () => {
        const res = await api.match(state.matchId);
        if (res && +res.code === 1) {
            $('.j-popup').fadeOut();
            $('.j-quiz-item-btn' + state.curZan).addClass('active');
            $('.j-quiz-item-btn' + zanMap[state.curZan]).addClass('disable');
            quizArr.push(state.matchId);
        } else {
            if (+res.code === 21005) {
                $('.j-popup').fadeOut();
                $('.j-popup-quiznoopen').fadeIn();
                return;
            }
            if (+res.code === 21006) {
                showTips(getText('quizEnd'));
                return;
            }
            if (+res.code === 21007) {
                showTips(getText('commonTip'));
                return;
            }
            if (+res.code === 21003) {
                showTips(getText('popupTip1'));
                return;
            }
            showTips(getText('commonTip'));
        }
    });
    $('body').on('click', '.j-date-item', function ({ target }) {
        if (!target.dataset.num) {
            return;
        }
        const index = ~~target.dataset.num;
        $('.j-date-item').removeClass('active');
        $(this).addClass('active');
        $('.j-quiz-item-title').html(getText('quizItemText' + index));
        for (let i = 1; i < 9; i++) {
            $('.j-quiz-item-btn' + i).removeClass('active').removeClass('disable');
        }
        if (index === 1) {
            for (let i = 1; i < 5; i++) {
                $('.j-quiz-item' + i).show();
            }
            if (state.isTh) {
                $('.j-quiz-item-btn1').attr('data-id', numMap['16-17'].id);
                $('.j-quiz-item-btn2').attr('data-id', numMap['16-18'].id);
                $('.j-quiz-item-btn3').attr('data-id', numMap['16-19'].id);
                $('.j-quiz-item-btn4').attr('data-id', numMap['16-20'].id);
                $('.j-quiz-item-btn5').attr('data-id', numMap['16-21'].id);
                $('.j-quiz-item-btn6').attr('data-id', numMap['16-22'].id);
                $('.j-quiz-item-btn7').attr('data-id', numMap['16-23'].id);
                $('.j-quiz-item-btn8').attr('data-id', numMap['16-24'].id);
                $('.j-head-name1').html(numMap['16-17'].name);
                $('.j-head-name2').html(numMap['16-18'].name);
                $('.j-head-name3').html(numMap['16-19'].name);
                $('.j-head-name4').html(numMap['16-20'].name);
                $('.j-head-name5').html(numMap['16-21'].name);
                $('.j-head-name6').html(numMap['16-22'].name);
                $('.j-head-name7').html(numMap['16-23'].name);
                $('.j-head-name8').html(numMap['16-24'].name);
                $('.j-quiz-item-icon1').removeClass('head-icon1 head-icon2 head-icon3 head-icon4 head-icon5 head-icon6 head-icon7 head-icon8 head-icon9 head-icon10 head-icon11 head-icon12 head-icon13 head-icon14 head-icon15 head-icon16').addClass(numMap['16-17'].headicon);
                $('.j-quiz-item-icon2').removeClass('head-icon1 head-icon2 head-icon3 head-icon4 head-icon5 head-icon6 head-icon7 head-icon8 head-icon9 head-icon10 head-icon11 head-icon12 head-icon13 head-icon14 head-icon15 head-icon16').addClass(numMap['16-18'].headicon);
                $('.j-quiz-item-icon3').removeClass('head-icon1 head-icon2 head-icon3 head-icon4 head-icon5 head-icon6 head-icon7 head-icon8 head-icon9 head-icon10 head-icon11 head-icon12 head-icon13 head-icon14 head-icon15 head-icon16').addClass(numMap['16-19'].headicon);
                $('.j-quiz-item-icon4').removeClass('head-icon1 head-icon2 head-icon3 head-icon4 head-icon5 head-icon6 head-icon7 head-icon8 head-icon9 head-icon10 head-icon11 head-icon12 head-icon13 head-icon14 head-icon15 head-icon16').addClass(numMap['16-20'].headicon);
                $('.j-quiz-item-icon5').removeClass('head-icon1 head-icon2 head-icon3 head-icon4 head-icon5 head-icon6 head-icon7 head-icon8 head-icon9 head-icon10 head-icon11 head-icon12 head-icon13 head-icon14 head-icon15 head-icon16').addClass(numMap['16-21'].headicon);
                $('.j-quiz-item-icon6').removeClass('head-icon1 head-icon2 head-icon3 head-icon4 head-icon5 head-icon6 head-icon7 head-icon8 head-icon9 head-icon10 head-icon11 head-icon12 head-icon13 head-icon14 head-icon15 head-icon16').addClass(numMap['16-22'].headicon);
                $('.j-quiz-item-icon7').removeClass('head-icon1 head-icon2 head-icon3 head-icon4 head-icon5 head-icon6 head-icon7 head-icon8 head-icon9 head-icon10 head-icon11 head-icon12 head-icon13 head-icon14 head-icon15 head-icon16').addClass(numMap['16-23'].headicon);
                $('.j-quiz-item-icon8').removeClass('head-icon1 head-icon2 head-icon3 head-icon4 head-icon5 head-icon6 head-icon7 head-icon8 head-icon9 head-icon10 head-icon11 head-icon12 head-icon13 head-icon14 head-icon15 head-icon16').addClass(numMap['16-24'].headicon);
                if (quizArr.includes('16-17')) {
                    $('.j-quiz-item-btn1').addClass('active');
                    $('.j-quiz-item-btn2').addClass('disable');
                }
                if (quizArr.includes('16-18')) {
                    $('.j-quiz-item-btn2').addClass('active');
                    $('.j-quiz-item-btn1').addClass('disable');
                }
                if (quizArr.includes('16-19')) {
                    $('.j-quiz-item-btn3').addClass('active');
                    $('.j-quiz-item-btn4').addClass('disable');
                }
                if (quizArr.includes('16-20')) {
                    $('.j-quiz-item-btn4').addClass('active');
                    $('.j-quiz-item-btn3').addClass('disable');
                }
                if (quizArr.includes('16-21')) {
                    $('.j-quiz-item-btn5').addClass('active');
                    $('.j-quiz-item-btn6').addClass('disable');
                }
                if (quizArr.includes('16-22')) {
                    $('.j-quiz-item-btn6').addClass('active');
                    $('.j-quiz-item-btn5').addClass('disable');
                }
                if (quizArr.includes('16-23')) {
                    $('.j-quiz-item-btn7').addClass('active');
                    $('.j-quiz-item-btn8').addClass('disable');
                }
                if (quizArr.includes('16-24')) {
                    $('.j-quiz-item-btn8').addClass('active');
                    $('.j-quiz-item-btn7').addClass('disable');
                }
            } else {
                $('.j-quiz-item-btn1').attr('data-id', numMap['16-1'].id);
                $('.j-quiz-item-btn2').attr('data-id', numMap['16-2'].id);
                $('.j-quiz-item-btn3').attr('data-id', numMap['16-3'].id);
                $('.j-quiz-item-btn4').attr('data-id', numMap['16-4'].id);
                $('.j-quiz-item-btn5').attr('data-id', numMap['16-5'].id);
                $('.j-quiz-item-btn6').attr('data-id', numMap['16-6'].id);
                $('.j-quiz-item-btn7').attr('data-id', numMap['16-7'].id);
                $('.j-quiz-item-btn8').attr('data-id', numMap['16-8'].id);
                $('.j-head-name1').html(numMap['16-1'].name);
                $('.j-head-name2').html(numMap['16-2'].name);
                $('.j-head-name3').html(numMap['16-3'].name);
                $('.j-head-name4').html(numMap['16-4'].name);
                $('.j-head-name5').html(numMap['16-5'].name);
                $('.j-head-name6').html(numMap['16-6'].name);
                $('.j-head-name7').html(numMap['16-7'].name);
                $('.j-head-name8').html(numMap['16-8'].name);
                $('.j-quiz-item-icon1').removeClass('head-icon1 head-icon2 head-icon3 head-icon4 head-icon5 head-icon6 head-icon7 head-icon8 head-icon9 head-icon10 head-icon11 head-icon12 head-icon13 head-icon14 head-icon15 head-icon16').addClass(numMap['16-1'].headicon);
                $('.j-quiz-item-icon2').removeClass('head-icon1 head-icon2 head-icon3 head-icon4 head-icon5 head-icon6 head-icon7 head-icon8 head-icon9 head-icon10 head-icon11 head-icon12 head-icon13 head-icon14 head-icon15 head-icon16').addClass(numMap['16-2'].headicon);
                $('.j-quiz-item-icon3').removeClass('head-icon1 head-icon2 head-icon3 head-icon4 head-icon5 head-icon6 head-icon7 head-icon8 head-icon9 head-icon10 head-icon11 head-icon12 head-icon13 head-icon14 head-icon15 head-icon16').addClass(numMap['16-3'].headicon);
                $('.j-quiz-item-icon4').removeClass('head-icon1 head-icon2 head-icon3 head-icon4 head-icon5 head-icon6 head-icon7 head-icon8 head-icon9 head-icon10 head-icon11 head-icon12 head-icon13 head-icon14 head-icon15 head-icon16').addClass(numMap['16-4'].headicon);
                $('.j-quiz-item-icon5').removeClass('head-icon1 head-icon2 head-icon3 head-icon4 head-icon5 head-icon6 head-icon7 head-icon8 head-icon9 head-icon10 head-icon11 head-icon12 head-icon13 head-icon14 head-icon15 head-icon16').addClass(numMap['16-5'].headicon);
                $('.j-quiz-item-icon6').removeClass('head-icon1 head-icon2 head-icon3 head-icon4 head-icon5 head-icon6 head-icon7 head-icon8 head-icon9 head-icon10 head-icon11 head-icon12 head-icon13 head-icon14 head-icon15 head-icon16').addClass(numMap['16-6'].headicon);
                $('.j-quiz-item-icon7').removeClass('head-icon1 head-icon2 head-icon3 head-icon4 head-icon5 head-icon6 head-icon7 head-icon8 head-icon9 head-icon10 head-icon11 head-icon12 head-icon13 head-icon14 head-icon15 head-icon16').addClass(numMap['16-7'].headicon);
                $('.j-quiz-item-icon8').removeClass('head-icon1 head-icon2 head-icon3 head-icon4 head-icon5 head-icon6 head-icon7 head-icon8 head-icon9 head-icon10 head-icon11 head-icon12 head-icon13 head-icon14 head-icon15 head-icon16').addClass(numMap['16-8'].headicon);
                if (quizArr.includes('16-1')) {
                    $('.j-quiz-item-btn1').addClass('active');
                    $('.j-quiz-item-btn2').addClass('disable');
                }
                if (quizArr.includes('16-2')) {
                    $('.j-quiz-item-btn2').addClass('active');
                    $('.j-quiz-item-btn1').addClass('disable');
                }
                if (quizArr.includes('16-3')) {
                    $('.j-quiz-item-btn3').addClass('active');
                    $('.j-quiz-item-btn4').addClass('disable');
                }
                if (quizArr.includes('16-4')) {
                    $('.j-quiz-item-btn4').addClass('active');
                    $('.j-quiz-item-btn3').addClass('disable');
                }
                if (quizArr.includes('16-5')) {
                    $('.j-quiz-item-btn5').addClass('active');
                    $('.j-quiz-item-btn6').addClass('disable');
                }
                if (quizArr.includes('16-6')) {
                    $('.j-quiz-item-btn6').addClass('active');
                    $('.j-quiz-item-btn5').addClass('disable');
                }
                if (quizArr.includes('16-7')) {
                    $('.j-quiz-item-btn7').addClass('active');
                    $('.j-quiz-item-btn8').addClass('disable');
                }
                if (quizArr.includes('16-8')) {
                    $('.j-quiz-item-btn8').addClass('active');
                    $('.j-quiz-item-btn7').addClass('disable');
                }
            }
        }
        if (index === 2) {
            for (let i = 1; i < 5; i++) {
                $('.j-quiz-item' + i).show();
            }
            if (state.isTh) {
                $('.j-quiz-item-btn1').attr('data-id', numMap['16-25'].id);
                $('.j-quiz-item-btn2').attr('data-id', numMap['16-26'].id);
                $('.j-quiz-item-btn3').attr('data-id', numMap['16-27'].id);
                $('.j-quiz-item-btn4').attr('data-id', numMap['16-28'].id);
                $('.j-quiz-item-btn5').attr('data-id', numMap['16-29'].id);
                $('.j-quiz-item-btn6').attr('data-id', numMap['16-30'].id);
                $('.j-quiz-item-btn7').attr('data-id', numMap['16-31'].id);
                $('.j-quiz-item-btn8').attr('data-id', numMap['16-32'].id);
                $('.j-head-name1').html(numMap['16-25'].name);
                $('.j-head-name2').html(numMap['16-26'].name);
                $('.j-head-name3').html(numMap['16-27'].name);
                $('.j-head-name4').html(numMap['16-28'].name);
                $('.j-head-name5').html(numMap['16-29'].name);
                $('.j-head-name6').html(numMap['16-30'].name);
                $('.j-head-name7').html(numMap['16-31'].name);
                $('.j-head-name8').html(numMap['16-32'].name);
                $('.j-quiz-item-icon1').removeClass('head-icon1 head-icon2 head-icon3 head-icon4 head-icon5 head-icon6 head-icon7 head-icon8 head-icon9 head-icon10 head-icon11 head-icon12 head-icon13 head-icon14 head-icon15 head-icon16').addClass(numMap['16-25'].headicon);
                $('.j-quiz-item-icon2').removeClass('head-icon1 head-icon2 head-icon3 head-icon4 head-icon5 head-icon6 head-icon7 head-icon8 head-icon9 head-icon10 head-icon11 head-icon12 head-icon13 head-icon14 head-icon15 head-icon16').addClass(numMap['16-26'].headicon);
                $('.j-quiz-item-icon3').removeClass('head-icon1 head-icon2 head-icon3 head-icon4 head-icon5 head-icon6 head-icon7 head-icon8 head-icon9 head-icon10 head-icon11 head-icon12 head-icon13 head-icon14 head-icon15 head-icon16').addClass(numMap['16-27'].headicon);
                $('.j-quiz-item-icon4').removeClass('head-icon1 head-icon2 head-icon3 head-icon4 head-icon5 head-icon6 head-icon7 head-icon8 head-icon9 head-icon10 head-icon11 head-icon12 head-icon13 head-icon14 head-icon15 head-icon16').addClass(numMap['16-28'].headicon);
                $('.j-quiz-item-icon5').removeClass('head-icon1 head-icon2 head-icon3 head-icon4 head-icon5 head-icon6 head-icon7 head-icon8 head-icon9 head-icon10 head-icon11 head-icon12 head-icon13 head-icon14 head-icon15 head-icon16').addClass(numMap['16-29'].headicon);
                $('.j-quiz-item-icon6').removeClass('head-icon1 head-icon2 head-icon3 head-icon4 head-icon5 head-icon6 head-icon7 head-icon8 head-icon9 head-icon10 head-icon11 head-icon12 head-icon13 head-icon14 head-icon15 head-icon16').addClass(numMap['16-30'].headicon);
                $('.j-quiz-item-icon7').removeClass('head-icon1 head-icon2 head-icon3 head-icon4 head-icon5 head-icon6 head-icon7 head-icon8 head-icon9 head-icon10 head-icon11 head-icon12 head-icon13 head-icon14 head-icon15 head-icon16').addClass(numMap['16-31'].headicon);
                $('.j-quiz-item-icon8').removeClass('head-icon1 head-icon2 head-icon3 head-icon4 head-icon5 head-icon6 head-icon7 head-icon8 head-icon9 head-icon10 head-icon11 head-icon12 head-icon13 head-icon14 head-icon15 head-icon16').addClass(numMap['16-32'].headicon);
                if (quizArr.includes('16-25')) {
                    $('.j-quiz-item-btn1').addClass('active');
                    $('.j-quiz-item-btn2').addClass('disable');
                }
                if (quizArr.includes('16-26')) {
                    $('.j-quiz-item-btn2').addClass('active');
                    $('.j-quiz-item-btn1').addClass('disable');
                }
                if (quizArr.includes('16-27')) {
                    $('.j-quiz-item-btn3').addClass('active');
                    $('.j-quiz-item-btn4').addClass('disable');
                }
                if (quizArr.includes('16-28')) {
                    $('.j-quiz-item-btn4').addClass('active');
                    $('.j-quiz-item-btn3').addClass('disable');
                }
                if (quizArr.includes('16-29')) {
                    $('.j-quiz-item-btn5').addClass('active');
                    $('.j-quiz-item-btn6').addClass('disable');
                }
                if (quizArr.includes('16-30')) {
                    $('.j-quiz-item-btn6').addClass('active');
                    $('.j-quiz-item-btn5').addClass('disable');
                }
                if (quizArr.includes('16-31')) {
                    $('.j-quiz-item-btn7').addClass('active');
                    $('.j-quiz-item-btn8').addClass('disable');
                }
                if (quizArr.includes('16-32')) {
                    $('.j-quiz-item-btn8').addClass('active');
                    $('.j-quiz-item-btn7').addClass('disable');
                }
            } else {
                $('.j-quiz-item-btn1').attr('data-id', numMap['16-9'].id);
                $('.j-quiz-item-btn2').attr('data-id', numMap['16-10'].id);
                $('.j-quiz-item-btn3').attr('data-id', numMap['16-11'].id);
                $('.j-quiz-item-btn4').attr('data-id', numMap['16-12'].id);
                $('.j-quiz-item-btn5').attr('data-id', numMap['16-13'].id);
                $('.j-quiz-item-btn6').attr('data-id', numMap['16-14'].id);
                $('.j-quiz-item-btn7').attr('data-id', numMap['16-15'].id);
                $('.j-quiz-item-btn8').attr('data-id', numMap['16-16'].id);
                $('.j-head-name1').html(numMap['16-9'].name);
                $('.j-head-name2').html(numMap['16-10'].name);
                $('.j-head-name3').html(numMap['16-11'].name);
                $('.j-head-name4').html(numMap['16-12'].name);
                $('.j-head-name5').html(numMap['16-13'].name);
                $('.j-head-name6').html(numMap['16-14'].name);
                $('.j-head-name7').html(numMap['16-15'].name);
                $('.j-head-name8').html(numMap['16-16'].name);
                $('.j-quiz-item-icon1').removeClass('head-icon1 head-icon2 head-icon3 head-icon4 head-icon5 head-icon6 head-icon7 head-icon8 head-icon9 head-icon10 head-icon11 head-icon12 head-icon13 head-icon14 head-icon15 head-icon16').addClass(numMap['16-9'].headicon);
                $('.j-quiz-item-icon2').removeClass('head-icon1 head-icon2 head-icon3 head-icon4 head-icon5 head-icon6 head-icon7 head-icon8 head-icon9 head-icon10 head-icon11 head-icon12 head-icon13 head-icon14 head-icon15 head-icon16').addClass(numMap['16-10'].headicon);
                $('.j-quiz-item-icon3').removeClass('head-icon1 head-icon2 head-icon3 head-icon4 head-icon5 head-icon6 head-icon7 head-icon8 head-icon9 head-icon10 head-icon11 head-icon12 head-icon13 head-icon14 head-icon15 head-icon16').addClass(numMap['16-11'].headicon);
                $('.j-quiz-item-icon4').removeClass('head-icon1 head-icon2 head-icon3 head-icon4 head-icon5 head-icon6 head-icon7 head-icon8 head-icon9 head-icon10 head-icon11 head-icon12 head-icon13 head-icon14 head-icon15 head-icon16').addClass(numMap['16-12'].headicon);
                $('.j-quiz-item-icon5').removeClass('head-icon1 head-icon2 head-icon3 head-icon4 head-icon5 head-icon6 head-icon7 head-icon8 head-icon9 head-icon10 head-icon11 head-icon12 head-icon13 head-icon14 head-icon15 head-icon16').addClass(numMap['16-13'].headicon);
                $('.j-quiz-item-icon6').removeClass('head-icon1 head-icon2 head-icon3 head-icon4 head-icon5 head-icon6 head-icon7 head-icon8 head-icon9 head-icon10 head-icon11 head-icon12 head-icon13 head-icon14 head-icon15 head-icon16').addClass(numMap['16-14'].headicon);
                $('.j-quiz-item-icon7').removeClass('head-icon1 head-icon2 head-icon3 head-icon4 head-icon5 head-icon6 head-icon7 head-icon8 head-icon9 head-icon10 head-icon11 head-icon12 head-icon13 head-icon14 head-icon15 head-icon16').addClass(numMap['16-15'].headicon);
                $('.j-quiz-item-icon8').removeClass('head-icon1 head-icon2 head-icon3 head-icon4 head-icon5 head-icon6 head-icon7 head-icon8 head-icon9 head-icon10 head-icon11 head-icon12 head-icon13 head-icon14 head-icon15 head-icon16').addClass(numMap['16-16'].headicon);
                if (quizArr.includes('16-9')) {
                    $('.j-quiz-item-btn1').addClass('active');
                    $('.j-quiz-item-btn2').addClass('disable');
                }
                if (quizArr.includes('16-10')) {
                    $('.j-quiz-item-btn2').addClass('active');
                    $('.j-quiz-item-btn1').addClass('disable');
                }
                if (quizArr.includes('16-11')) {
                    $('.j-quiz-item-btn3').addClass('active');
                    $('.j-quiz-item-btn4').addClass('disable');
                }
                if (quizArr.includes('16-12')) {
                    $('.j-quiz-item-btn4').addClass('active');
                    $('.j-quiz-item-btn3').addClass('disable');
                }
                if (quizArr.includes('16-13')) {
                    $('.j-quiz-item-btn5').addClass('active');
                    $('.j-quiz-item-btn6').addClass('disable');
                }
                if (quizArr.includes('16-14')) {
                    $('.j-quiz-item-btn6').addClass('active');
                    $('.j-quiz-item-btn5').addClass('disable');
                }
                if (quizArr.includes('16-15')) {
                    $('.j-quiz-item-btn7').addClass('active');
                    $('.j-quiz-item-btn8').addClass('disable');
                }
                if (quizArr.includes('16-16')) {
                    $('.j-quiz-item-btn8').addClass('active');
                    $('.j-quiz-item-btn7').addClass('disable');
                }
            }
        }
        if (index === 3) {
            for (let i = 1; i < 5; i++) {
                $('.j-quiz-item' + i).show();
            }
            if (state.isTh) {
                $('.j-quiz-item-btn1').attr('data-id', numMap['8-9'].id);
                $('.j-quiz-item-btn2').attr('data-id', numMap['8-10'].id);
                $('.j-quiz-item-btn3').attr('data-id', numMap['8-11'].id);
                $('.j-quiz-item-btn4').attr('data-id', numMap['8-12'].id);
                $('.j-quiz-item-btn5').attr('data-id', numMap['8-13'].id);
                $('.j-quiz-item-btn6').attr('data-id', numMap['8-14'].id);
                $('.j-quiz-item-btn7').attr('data-id', numMap['8-15'].id);
                $('.j-quiz-item-btn8').attr('data-id', numMap['8-16'].id);
                $('.j-head-name1').html(numMap['8-9'].name);
                $('.j-head-name2').html(numMap['8-10'].name);
                $('.j-head-name3').html(numMap['8-11'].name);
                $('.j-head-name4').html(numMap['8-12'].name);
                $('.j-head-name5').html(numMap['8-13'].name);
                $('.j-head-name6').html(numMap['8-14'].name);
                $('.j-head-name7').html(numMap['8-15'].name);
                $('.j-head-name8').html(numMap['8-16'].name);
                $('.j-quiz-item-icon1').removeClass('head-icon1 head-icon2 head-icon3 head-icon4 head-icon5 head-icon6 head-icon7 head-icon8 head-icon9 head-icon10 head-icon11 head-icon12 head-icon13 head-icon14 head-icon15 head-icon16').addClass(numMap['8-9'].headicon);
                $('.j-quiz-item-icon2').removeClass('head-icon1 head-icon2 head-icon3 head-icon4 head-icon5 head-icon6 head-icon7 head-icon8 head-icon9 head-icon10 head-icon11 head-icon12 head-icon13 head-icon14 head-icon15 head-icon16').addClass(numMap['8-10'].headicon);
                $('.j-quiz-item-icon3').removeClass('head-icon1 head-icon2 head-icon3 head-icon4 head-icon5 head-icon6 head-icon7 head-icon8 head-icon9 head-icon10 head-icon11 head-icon12 head-icon13 head-icon14 head-icon15 head-icon16').addClass(numMap['8-11'].headicon);
                $('.j-quiz-item-icon4').removeClass('head-icon1 head-icon2 head-icon3 head-icon4 head-icon5 head-icon6 head-icon7 head-icon8 head-icon9 head-icon10 head-icon11 head-icon12 head-icon13 head-icon14 head-icon15 head-icon16').addClass(numMap['8-12'].headicon);
                $('.j-quiz-item-icon5').removeClass('head-icon1 head-icon2 head-icon3 head-icon4 head-icon5 head-icon6 head-icon7 head-icon8 head-icon9 head-icon10 head-icon11 head-icon12 head-icon13 head-icon14 head-icon15 head-icon16').addClass(numMap['8-13'].headicon);
                $('.j-quiz-item-icon6').removeClass('head-icon1 head-icon2 head-icon3 head-icon4 head-icon5 head-icon6 head-icon7 head-icon8 head-icon9 head-icon10 head-icon11 head-icon12 head-icon13 head-icon14 head-icon15 head-icon16').addClass(numMap['8-14'].headicon);
                $('.j-quiz-item-icon7').removeClass('head-icon1 head-icon2 head-icon3 head-icon4 head-icon5 head-icon6 head-icon7 head-icon8 head-icon9 head-icon10 head-icon11 head-icon12 head-icon13 head-icon14 head-icon15 head-icon16').addClass(numMap['8-15'].headicon);
                $('.j-quiz-item-icon8').removeClass('head-icon1 head-icon2 head-icon3 head-icon4 head-icon5 head-icon6 head-icon7 head-icon8 head-icon9 head-icon10 head-icon11 head-icon12 head-icon13 head-icon14 head-icon15 head-icon16').addClass(numMap['8-16'].headicon);
                if (quizArr.includes('8-9')) {
                    $('.j-quiz-item-btn1').addClass('active');
                    $('.j-quiz-item-btn2').addClass('disable');
                }
                if (quizArr.includes('8-10')) {
                    $('.j-quiz-item-btn2').addClass('active');
                    $('.j-quiz-item-btn1').addClass('disable');
                }
                if (quizArr.includes('8-11')) {
                    $('.j-quiz-item-btn3').addClass('active');
                    $('.j-quiz-item-btn4').addClass('disable');
                }
                if (quizArr.includes('8-12')) {
                    $('.j-quiz-item-btn4').addClass('active');
                    $('.j-quiz-item-btn3').addClass('disable');
                }
                if (quizArr.includes('8-13')) {
                    $('.j-quiz-item-btn5').addClass('active');
                    $('.j-quiz-item-btn6').addClass('disable');
                }
                if (quizArr.includes('8-14')) {
                    $('.j-quiz-item-btn6').addClass('active');
                    $('.j-quiz-item-btn5').addClass('disable');
                }
                if (quizArr.includes('8-15')) {
                    $('.j-quiz-item-btn7').addClass('active');
                    $('.j-quiz-item-btn8').addClass('disable');
                }
                if (quizArr.includes('8-16')) {
                    $('.j-quiz-item-btn8').addClass('active');
                    $('.j-quiz-item-btn7').addClass('disable');
                }
            } else {
                $('.j-quiz-item-btn1').attr('data-id', numMap['8-1'].id);
                $('.j-quiz-item-btn2').attr('data-id', numMap['8-2'].id);
                $('.j-quiz-item-btn3').attr('data-id', numMap['8-3'].id);
                $('.j-quiz-item-btn4').attr('data-id', numMap['8-4'].id);
                $('.j-quiz-item-btn5').attr('data-id', numMap['8-5'].id);
                $('.j-quiz-item-btn6').attr('data-id', numMap['8-6'].id);
                $('.j-quiz-item-btn7').attr('data-id', numMap['8-7'].id);
                $('.j-quiz-item-btn8').attr('data-id', numMap['8-8'].id);
                $('.j-head-name1').html(numMap['8-1'].name);
                $('.j-head-name2').html(numMap['8-2'].name);
                $('.j-head-name3').html(numMap['8-3'].name);
                $('.j-head-name4').html(numMap['8-4'].name);
                $('.j-head-name5').html(numMap['8-5'].name);
                $('.j-head-name6').html(numMap['8-6'].name);
                $('.j-head-name7').html(numMap['8-7'].name);
                $('.j-head-name8').html(numMap['8-8'].name);
                $('.j-quiz-item-icon1').removeClass('head-icon1 head-icon2 head-icon3 head-icon4 head-icon5 head-icon6 head-icon7 head-icon8 head-icon9 head-icon10 head-icon11 head-icon12 head-icon13 head-icon14 head-icon15 head-icon16').addClass(numMap['8-1'].headicon);
                $('.j-quiz-item-icon2').removeClass('head-icon1 head-icon2 head-icon3 head-icon4 head-icon5 head-icon6 head-icon7 head-icon8 head-icon9 head-icon10 head-icon11 head-icon12 head-icon13 head-icon14 head-icon15 head-icon16').addClass(numMap['8-2'].headicon);
                $('.j-quiz-item-icon3').removeClass('head-icon1 head-icon2 head-icon3 head-icon4 head-icon5 head-icon6 head-icon7 head-icon8 head-icon9 head-icon10 head-icon11 head-icon12 head-icon13 head-icon14 head-icon15 head-icon16').addClass(numMap['8-3'].headicon);
                $('.j-quiz-item-icon4').removeClass('head-icon1 head-icon2 head-icon3 head-icon4 head-icon5 head-icon6 head-icon7 head-icon8 head-icon9 head-icon10 head-icon11 head-icon12 head-icon13 head-icon14 head-icon15 head-icon16').addClass(numMap['8-4'].headicon);
                $('.j-quiz-item-icon5').removeClass('head-icon1 head-icon2 head-icon3 head-icon4 head-icon5 head-icon6 head-icon7 head-icon8 head-icon9 head-icon10 head-icon11 head-icon12 head-icon13 head-icon14 head-icon15 head-icon16').addClass(numMap['8-5'].headicon);
                $('.j-quiz-item-icon6').removeClass('head-icon1 head-icon2 head-icon3 head-icon4 head-icon5 head-icon6 head-icon7 head-icon8 head-icon9 head-icon10 head-icon11 head-icon12 head-icon13 head-icon14 head-icon15 head-icon16').addClass(numMap['8-6'].headicon);
                $('.j-quiz-item-icon7').removeClass('head-icon1 head-icon2 head-icon3 head-icon4 head-icon5 head-icon6 head-icon7 head-icon8 head-icon9 head-icon10 head-icon11 head-icon12 head-icon13 head-icon14 head-icon15 head-icon16').addClass(numMap['8-7'].headicon);
                $('.j-quiz-item-icon8').removeClass('head-icon1 head-icon2 head-icon3 head-icon4 head-icon5 head-icon6 head-icon7 head-icon8 head-icon9 head-icon10 head-icon11 head-icon12 head-icon13 head-icon14 head-icon15 head-icon16').addClass(numMap['8-8'].headicon);
                if (quizArr.includes('8-1')) {
                    $('.j-quiz-item-btn1').addClass('active');
                    $('.j-quiz-item-btn2').addClass('disable');
                }
                if (quizArr.includes('8-2')) {
                    $('.j-quiz-item-btn2').addClass('active');
                    $('.j-quiz-item-btn1').addClass('disable');
                }
                if (quizArr.includes('8-3')) {
                    $('.j-quiz-item-btn3').addClass('active');
                    $('.j-quiz-item-btn4').addClass('disable');
                }
                if (quizArr.includes('8-4')) {
                    $('.j-quiz-item-btn4').addClass('active');
                    $('.j-quiz-item-btn3').addClass('disable');
                }
                if (quizArr.includes('8-5')) {
                    $('.j-quiz-item-btn5').addClass('active');
                    $('.j-quiz-item-btn6').addClass('disable');
                }
                if (quizArr.includes('8-6')) {
                    $('.j-quiz-item-btn6').addClass('active');
                    $('.j-quiz-item-btn5').addClass('disable');
                }
                if (quizArr.includes('8-7')) {
                    $('.j-quiz-item-btn7').addClass('active');
                    $('.j-quiz-item-btn8').addClass('disable');
                }
                if (quizArr.includes('8-8')) {
                    $('.j-quiz-item-btn8').addClass('active');
                    $('.j-quiz-item-btn7').addClass('disable');
                }
            }

        }
        if (index === 4) {
            for (let i = 1; i < 3; i++) {
                $('.j-quiz-item' + i).show();
            }
            for (let i = 3; i < 5; i++) {
                $('.j-quiz-item' + i).hide();
            }
            if (state.isTh) {
                $('.j-quiz-item-btn1').attr('data-id', numMap['4-5'].id);
                $('.j-quiz-item-btn2').attr('data-id', numMap['4-6'].id);
                $('.j-quiz-item-btn3').attr('data-id', numMap['4-7'].id);
                $('.j-quiz-item-btn4').attr('data-id', numMap['4-8'].id);
                $('.j-head-name1').html(numMap['4-5'].name);
                $('.j-head-name2').html(numMap['4-6'].name);
                $('.j-head-name3').html(numMap['4-7'].name);
                $('.j-head-name4').html(numMap['4-8'].name);
                $('.j-quiz-item-icon1').removeClass('head-icon1 head-icon2 head-icon3 head-icon4 head-icon5 head-icon6 head-icon7 head-icon8 head-icon9 head-icon10 head-icon11 head-icon12 head-icon13 head-icon14 head-icon15 head-icon16').addClass(numMap['4-5'].headicon);
                $('.j-quiz-item-icon2').removeClass('head-icon1 head-icon2 head-icon3 head-icon4 head-icon5 head-icon6 head-icon7 head-icon8 head-icon9 head-icon10 head-icon11 head-icon12 head-icon13 head-icon14 head-icon15 head-icon16').addClass(numMap['4-6'].headicon);
                $('.j-quiz-item-icon3').removeClass('head-icon1 head-icon2 head-icon3 head-icon4 head-icon5 head-icon6 head-icon7 head-icon8 head-icon9 head-icon10 head-icon11 head-icon12 head-icon13 head-icon14 head-icon15 head-icon16').addClass(numMap['4-7'].headicon);
                $('.j-quiz-item-icon4').removeClass('head-icon1 head-icon2 head-icon3 head-icon4 head-icon5 head-icon6 head-icon7 head-icon8 head-icon9 head-icon10 head-icon11 head-icon12 head-icon13 head-icon14 head-icon15 head-icon16').addClass(numMap['4-8'].headicon);
                if (quizArr.includes('4-5')) {
                    $('.j-quiz-item-btn1').addClass('active');
                    $('.j-quiz-item-btn2').addClass('disable');
                }
                if (quizArr.includes('4-6')) {
                    $('.j-quiz-item-btn2').addClass('active');
                    $('.j-quiz-item-btn1').addClass('disable');
                }
                if (quizArr.includes('4-7')) {
                    $('.j-quiz-item-btn3').addClass('active');
                    $('.j-quiz-item-btn4').addClass('disable');
                }
                if (quizArr.includes('4-8')) {
                    $('.j-quiz-item-btn4').addClass('active');
                    $('.j-quiz-item-btn3').addClass('disable');
                }
            } else {
                $('.j-quiz-item3').show();
                $('.j-quiz-item-btn1').attr('data-id', numMap['4-1'].id);
                $('.j-quiz-item-btn2').attr('data-id', numMap['4-2'].id);
                $('.j-quiz-item-btn3').attr('data-id', numMap['4-3'].id);
                $('.j-quiz-item-btn4').attr('data-id', numMap['4-4'].id);
                $('.j-quiz-item-btn5').attr('data-id', numMap['2-1'].id);
                $('.j-quiz-item-btn6').attr('data-id', numMap['2-2'].id);
                $('.j-head-name1').html(numMap['4-1'].name);
                $('.j-head-name2').html(numMap['4-2'].name);
                $('.j-head-name3').html(numMap['4-3'].name);
                $('.j-head-name4').html(numMap['4-4'].name);
                $('.j-head-name5').html(numMap['2-1'].name);
                $('.j-head-name6').html(numMap['2-2'].name);
                $('.j-quiz-item-icon1').removeClass('head-icon1 head-icon2 head-icon3 head-icon4 head-icon5 head-icon6 head-icon7 head-icon8 head-icon9 head-icon10 head-icon11 head-icon12 head-icon13 head-icon14 head-icon15 head-icon16').addClass(numMap['4-1'].headicon);
                $('.j-quiz-item-icon2').removeClass('head-icon1 head-icon2 head-icon3 head-icon4 head-icon5 head-icon6 head-icon7 head-icon8 head-icon9 head-icon10 head-icon11 head-icon12 head-icon13 head-icon14 head-icon15 head-icon16').addClass(numMap['4-2'].headicon);
                $('.j-quiz-item-icon3').removeClass('head-icon1 head-icon2 head-icon3 head-icon4 head-icon5 head-icon6 head-icon7 head-icon8 head-icon9 head-icon10 head-icon11 head-icon12 head-icon13 head-icon14 head-icon15 head-icon16').addClass(numMap['4-3'].headicon);
                $('.j-quiz-item-icon4').removeClass('head-icon1 head-icon2 head-icon3 head-icon4 head-icon5 head-icon6 head-icon7 head-icon8 head-icon9 head-icon10 head-icon11 head-icon12 head-icon13 head-icon14 head-icon15 head-icon16').addClass(numMap['4-4'].headicon);
                $('.j-quiz-item-icon5').removeClass('head-icon1 head-icon2 head-icon3 head-icon4 head-icon5 head-icon6 head-icon7 head-icon8 head-icon9 head-icon10 head-icon11 head-icon12 head-icon13 head-icon14 head-icon15 head-icon16').addClass(numMap['2-1'].headicon);
                $('.j-quiz-item-icon6').removeClass('head-icon1 head-icon2 head-icon3 head-icon4 head-icon5 head-icon6 head-icon7 head-icon8 head-icon9 head-icon10 head-icon11 head-icon12 head-icon13 head-icon14 head-icon15 head-icon16').addClass(numMap['2-2'].headicon);
                if (quizArr.includes('4-1')) {
                    $('.j-quiz-item-btn1').addClass('active');
                    $('.j-quiz-item-btn2').addClass('disable');
                }
                if (quizArr.includes('4-2')) {
                    $('.j-quiz-item-btn2').addClass('active');
                    $('.j-quiz-item-btn1').addClass('disable');
                }
                if (quizArr.includes('4-3')) {
                    $('.j-quiz-item-btn3').addClass('active');
                    $('.j-quiz-item-btn4').addClass('disable');
                }
                if (quizArr.includes('4-4')) {
                    $('.j-quiz-item-btn4').addClass('active');
                    $('.j-quiz-item-btn3').addClass('disable');
                }
                if (quizArr.includes('2-1')) {
                    $('.j-quiz-item-btn5').addClass('active');
                    $('.j-quiz-item-btn6').addClass('disable');
                }
                if (quizArr.includes('2-2')) {
                    $('.j-quiz-item-btn6').addClass('active');
                    $('.j-quiz-item-btn5').addClass('disable');
                }
            }

        }
        if (index === 5) {
            for (let i = 1; i < 2; i++) {
                $('.j-quiz-item' + i).show();
            }
            for (let i = 2; i < 5; i++) {
                $('.j-quiz-item' + i).hide();
            }
            if (state.isTh) {
                $('.j-quiz-item-btn1').attr('data-id', numMap['1-3'].id);
                $('.j-quiz-item-btn2').attr('data-id', numMap['1-4'].id);
                $('.j-head-name1').html(numMap['1-3'].name);
                $('.j-head-name2').html(numMap['1-4'].name);
                $('.j-quiz-item-icon1').removeClass('head-icon1 head-icon2 head-icon3 head-icon4 head-icon5 head-icon6 head-icon7 head-icon8 head-icon9 head-icon10 head-icon11 head-icon12 head-icon13 head-icon14 head-icon15 head-icon16').addClass(numMap['1-3'].headicon);
                $('.j-quiz-item-icon2').removeClass('head-icon1 head-icon2 head-icon3 head-icon4 head-icon5 head-icon6 head-icon7 head-icon8 head-icon9 head-icon10 head-icon11 head-icon12 head-icon13 head-icon14 head-icon15 head-icon16').addClass(numMap['1-4'].headicon);
                if (quizArr.includes('1-3')) {
                    $('.j-quiz-item-btn1').addClass('active');
                    $('.j-quiz-item-btn2').addClass('disable');
                }
                if (quizArr.includes('1-4')) {
                    $('.j-quiz-item-btn2').addClass('active');
                    $('.j-quiz-item-btn1').addClass('disable');
                }
            } else {
                $('.j-quiz-item-btn1').attr('data-id', numMap['1-1'].id);
                $('.j-quiz-item-btn2').attr('data-id', numMap['1-2'].id);
                $('.j-head-name1').html(numMap['1-1'].name);
                $('.j-head-name2').html(numMap['1-2'].name);
                $('.j-quiz-item-icon1').removeClass('head-icon1 head-icon2 head-icon3 head-icon4 head-icon5 head-icon6 head-icon7 head-icon8 head-icon9 head-icon10 head-icon11 head-icon12 head-icon13 head-icon14 head-icon15 head-icon16').addClass(numMap['1-1'].headicon);
                $('.j-quiz-item-icon2').removeClass('head-icon1 head-icon2 head-icon3 head-icon4 head-icon5 head-icon6 head-icon7 head-icon8 head-icon9 head-icon10 head-icon11 head-icon12 head-icon13 head-icon14 head-icon15 head-icon16').addClass(numMap['1-2'].headicon);
                if (quizArr.includes('1-1')) {
                    $('.j-quiz-item-btn1').addClass('active');
                    $('.j-quiz-item-btn2').addClass('disable');
                }
                if (quizArr.includes('1-2')) {
                    $('.j-quiz-item-btn2').addClass('active');
                    $('.j-quiz-item-btn1').addClass('disable');
                }
            }
        }
    });
    $('.j-my-quiz').on('click', async () => {
        if (!state.isLogin) {
            gotoLogin();
            return;
        }
        if (!state.isBind) {
            bindInit();
            $('.j-popup').fadeOut();
            $('.j-popup-juese').fadeIn()
            return;
        }
        const res = await api.history();
        if (res && +res.code === 1) {
            if (res.data.quizInfo) {
                let html = '';
                for (let i of bagArr) {
                    if (res.data.quizInfo[i] !== undefined) {
                        let resultText = '';
                        if (+res.data.quizInfo[i] === 0) {
                            resultText = '???';
                        }
                        if (+res.data.quizInfo[i] === 1) {
                            resultText = getText('quizSucc');
                        }
                        if (+res.data.quizInfo[i] === -1) {
                            resultText = getText('quizFail');
                        }
                        html += `<tr>
                        <td>${getText(numMap[i].session)}</td>
                        <td>${numMap[i].name}</td>
                        <td>${resultText}</td>
                        <td>${getText(numMap[i].award)}</td>
                        </tr>`;
                    }
                }
                $('.j-record-body').html(html);
                $('.j-record').show();
            }
        }
        $('.j-popup').fadeOut();
        $('.j-popup-myquiz').fadeIn()
    });
    $('.j-quiz-rule').on('click', () => {
        $('.j-popup').fadeOut();
        $('.j-popup-quizrule').fadeIn()
    });
    $('.j-fb-btn').on('click', () => {
        fbShare();
    });
    $('.j-go-btn').on('click', () => {
        if (state.lang.includes("th")) {
            window.open('https://sea.37games.com/dl3dvn/index.html?cid=&scid=')
        } else {
            window.open('https://dauladailuc3d.vn/')
        }
    });
    for (let i = 1; i < 6; i++) {
        $('.j-playback' + i).on('click', async () => {
            await basicInit();
            if (state.lang.includes('th')) {
                if (state.replayLink['th_replay_' + i]) {
                    jumpLink(state.replayLink['th_replay_' + i]);
                } else {
                    showTips(getText('wait'));
                }
            } else {
                if (state.replayLink['vi_replay_' + i]) {
                    jumpLink(state.replayLink['vi_replay_' + i]);
                } else {
                    showTips(getText('wait'));
                }
            }
        });
    }
    $('.j-scroll').on('click', function () {
        let scrollEleSelector = $(this).attr('data-scroll');
        let topNum = $(this).attr('data-top');
        $('html, body').animate(
            {
                scrollTop: $(scrollEleSelector).offset().top + parseInt(topNum),
            },
            500
        );
    });
    $('.j-logout-btn').on('click', function () {
        api.logout().then(() => {
            window.location.reload();
        });
    });

    $('.j-login-btn').on('click', async function () {
        gotoLogin();
    });

    $("body").on("click", ".j-live-btn", async function () {
        let isLiveTime = false;
        if (state.isTh) {
            isLiveTime = (compareTime('2023/03/01,19:00:00', '2023/03/01,23:00:00') === 0) || (compareTime('2023/03/03,19:00:00', '2023/03/03,23:00:00') === 0) || (compareTime('2023/03/09,19:00:00', '2023/03/09,23:00:00') === 0) || (compareTime('2023/03/10,19:00:00', '2023/03/10,23:00:00') === 0) || (compareTime('2023/03/17,19:00:00', '2023/03/17,23:00:00') === 0);
        } else {
            isLiveTime = (compareTime('2023/03/06,19:00:00', '2023/03/06,23:00:00') === 0) || (compareTime('2023/03/07,19:00:00', '2023/03/07,23:00:00') === 0) || (compareTime('2023/03/10,19:00:00', '2023/03/10,23:00:00') === 0) || (compareTime('2023/03/14,19:00:00', '2023/03/14,23:00:00') === 0) || (compareTime('2023/03/17,19:00:00', '2023/03/17,23:00:00') === 0);
        }
        //提示
        if (isLiveTime) {
            await basicInit();
            if (state.lang.includes('th')) {
                if (state.liveLink['th_live']) {
                    jumpLink(state.liveLink['th_live']);
                } else {
                    showTips(getText('gameNoStart'));
                }
            } else {
                if (state.liveLink['vi_live']) {
                    jumpLink(state.liveLink['vi_live']);
                } else {
                    showTips(getText('gameNoStart'));
                }
            }
        } else {
            showTips(getText('gameNoStart'));
        }
    });

    $('.j-bind').on('click', async function () {
        if (checkLogin()) {
            bindInit();
            $('.j-popup').fadeOut();
            $('.j-popup-juese').fadeIn();
        }
    });
    $('.j-popup-close').on('click', function () {
        $('.j-popup').fadeOut();
    });
    const renderServerList = data => {
        let html = `<option value="0">${getText('pServer')}</option>`;
        if (data && data.length) {
            data.map(item => {

                html += `<option value="${item.sid}" ${item.id == state.roleInfo.id ? 'selected' : ''
                    } data-id="${item.id}">${item.sname}</option>`;

            });
        }
        $('.j-select-server').html(html);
    };
    const renderRoleList = data => {
        let html = `<option value="0">${getText('pRole')}</option>`;
        if (data && data.length) {
            data.map(item => {
                html += `<option value="${item.roleID}" ${item.roleID == state.roleInfo.rid ? 'selected' : ''
                    }>${item.roleName}</option>`;
            });
        }
        $('.j-select-role').html(html);
    };
    const resetRoleList = () => {
        renderRoleList();
        $('.j-select-role').val(0);
    };
    const bindInit = async () => {
        resetRoleList();
        let serverListRes = await api.getServer();
        +serverListRes.result > 0
            ? renderServerList(serverListRes.data)
            : renderServerList();
        if (!state.isBind && state.roleInfo.sid && state.roleInfo.rid) {
            let curServerId = $('.j-select-server').val();
            let roleListRes = await api.getCharacter(curServerId);
            +roleListRes.result > 0
                ? renderRoleList(roleListRes.data)
                : renderRoleList();
        }
    };
    $('.j-select-server').on('change', async function () {
        let serverId = $(this).val();
        resetRoleList();
        if (serverId == 0) return;
        const res = await api.getServer();
        if (res && +res.code === 1) {
            for (let i = 0; i < res.data.length; i++) {
                if (res.data[i].sid == serverId) {
                    state.roleInfo.id = res.data[i].id;
                    break
                }
            }
        }
        let roleListRes = await api.getCharacter(serverId);
        +roleListRes.result > 0
            ? renderRoleList(roleListRes.data)
            : renderRoleList();
    });

    $('.j-popup-juese-confirm').on('click', async function () {
        let id = state.roleInfo.id;
        let sid = $('.j-select-server').val();
        let rid = $('.j-select-role').val();
        let sname = $('.j-select-server').find('option:selected').text();
        let rname = $('.j-select-role').find('option:selected').text();
        if (!sid || sid == 0) {
            alert(getText('pServer'));
            return;
        }
        if (!rid || rid == 0) {
            alert(getText('pRole'));
            return;
        }
        let charInfo = { id, sid, rid, sname, rname };
        state.roleInfo = Object.assign(charInfo, {});
        const res = await api.bind({ serverId: state.roleInfo.sid, roleId: state.roleInfo.rid, serverName: state.roleInfo.sname, roleName: state.roleInfo.rname, sId: state.roleInfo.id });
        if (res && +res.code === 1) {
            state.isBind = true;
            $(".j-bind").addClass("disable");
            roleInfoInit();
            $('.j-popup-juese').fadeOut();
            window.activityDataLayer.push({
                eventName: "bind",
                aid: "dlssrvtline2",
                roleId: state.roleInfo.rid,
                roleName: state.roleInfo.rname,
                serverId: state.roleInfo.sid,
                gameId: 274
            })
        } else {
            if (+res.code === 21004) {
                showTips(getText('popupTip2'));
                return;
            }
            showTips(getText('commonTip'));
        }
    });
};
